<div
  class="gender-dot"
  [ngClass]="['gender-' + gender, inline ? 'inline' : '']"
></div>
